import React from 'react';
import { AICoursesContainer } from '../private/components/AICoursesContainer';

export const SlAICourses = () => {
  return <AICoursesContainer />;
};